// ID of this Script must be ucmConfig
// Mirrors Openserve reference config ucmConfig2411osc.js (v=2412), used with
// the lmtc2411osc UCM API build. Hosted our side so we own the flags.

var BuildingInfo = "Y";
var bMessaging = true;
var bTechnology = true;
var bLayerSwitcher = false;
var bApp = false;
var bWeb = false;
var bShopify = true;
var bUPP = true;
var bProp = false;
var bProducts = true;
var bOrder = true;

// Path to API via rewrite rules or VHOST
var BASE_PATH = "//gis.telkom.co.za/apps/";
var BASE_API_PATH = "//gis.telkom.co.za/apps/";

// Path to GIS images (2411osc serves these from assets/, not api/)
var BASE_IMAGE_PATH = "//gis.telkom.co.za/apps/assets/images/";

// green or blue
var grpTHEME = "green";

var agentUA = "N";
